import { Reference, useMutation } from "@apollo/client";

import {
  CareTeamInviteCreateDocument,
  CareTeamInviteCreateMutation,
  CareTeamInviteCreateMutationVariables,
  CareTeamInviteFragmentDoc
} from "@typing/Generated";
import { JourneyFromSomeQuery } from "@typing/Models";

const useCareTeamInviteCreateMutation = (journey: JourneyFromSomeQuery) => {
  const [careTeamInviteCreate] = useMutation<CareTeamInviteCreateMutation, CareTeamInviteCreateMutationVariables>(
    CareTeamInviteCreateDocument,
    {
      update: (store, { data }) => {
        if (data?.careTeamInviteCreate?.careTeamInvite) {
          const newInvite = data.careTeamInviteCreate.careTeamInvite;
          store.modify({
            fields: {
              careTeamInvites(cachedInviteRefs: readonly Reference[]): Reference[] {
                const newInviteRef = store.writeFragment({
                  data: newInvite,
                  fragment: CareTeamInviteFragmentDoc,
                  fragmentName: "CareTeamInvite"
                });
                if (newInviteRef) {
                  return [...cachedInviteRefs, newInviteRef];
                }
                return [...cachedInviteRefs];
              }
            },
            id: store.identify({ __typename: "Journey", id: journey.id })
          });
        }
      }
    }
  );

  return careTeamInviteCreate;
};

export default useCareTeamInviteCreateMutation;
